import * as React from 'react';

const IMAGE_SRC = require('images/onboarding-inbox.png');

const InboxContents = () => {
  return <div><img src={IMAGE_SRC} /></div>;
}

export default InboxContents;
